export function trackBusinessProfileViewed(sdkContext) {
  if (!sdkContext) {
    return
  }

  sdkContext.trackConversion('profile-viewed', {
    ruleData: {
      value: true,
    },
  })

  // console.log('Conversion tracked: profile-viewed')
}

export function trackBusinessSocialViewed(sdkContext) {
  if (!sdkContext) {
    return
  }

  sdkContext.trackConversion('social-viewed', {
    ruleData: {
      value: true,
    },
  })

  // console.log('Conversion tracked: social-viewed')
}

export function trackBusinessWebsiteViewed(sdkContext) {
  if (!sdkContext) {
    return
  }

  sdkContext.trackConversion('website-viewed', {
    ruleData: {
      value: true,
    },
  })

  // console.log('Conversion tracked: website-viewed')
}

export function trackBusinessContactViewed(sdkContext) {
  if (!sdkContext) {
    return
  }

  sdkContext.trackConversion('contact-viewed', {
    ruleData: {
      value: true,
    },
  })

  // console.log('Conversion tracked: contact-viewed')
}
